import { render, staticRenderFns } from "./unionGoodsInvenEdit.vue?vue&type=template&id=424b79b0&scoped=true&"
import script from "./unionGoodsInvenEdit.vue?vue&type=script&lang=js&"
export * from "./unionGoodsInvenEdit.vue?vue&type=script&lang=js&"
import style0 from "./unionGoodsInvenEdit.vue?vue&type=style&index=0&id=424b79b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b79b0",
  null
  
)

component.options.__file = "unionGoodsInvenEdit.vue"
export default component.exports